import { render, staticRenderFns } from "./hygienic_measurement.vue?vue&type=template&id=573a57c2"
import script from "./hygienic_measurement.vue?vue&type=script&lang=js"
export * from "./hygienic_measurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports